import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import 'rxjs/add/operator/delay';
import { ApplicantService } from '../../services/apis/applicant.service';
import Form from './new-applicant.form.json';
import { FormsDataServiceInterface } from '../../../../../discoverer/dynamic-forms/dyn-forms/services/forms-data-service.interface';
import { IApplicantDto } from '../../../../models/dtos/applicant.dto';


@Injectable()
export class NewApplicantFormService implements FormsDataServiceInterface {
    constructor(private _applicantApiService: ApplicantService) {
    }
    public getFormByKey(key: string) {
        const form = Form.filter(f => f.Key === key)[0];
        const obj = {
            Key: key,
            Title: form.Title,
            Configuration: JSON.stringify(form.Configuration)
        };
        return of(obj).delay(1);
    }
    postFormData(applicant: any): Observable<IApplicantDto> {

        return this._applicantApiService.create(applicant);
    }
}

